export default window.sessionStorage;
